export default window.sessionStorage;
